import { Box } from "@mui/material";
import { NodeViewRendererProps, NodeViewWrapper } from "@tiptap/react";
import { DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { getLink } from "../../../taskManagement/taskPane/taskRelationsBox/TaskRelationsBox.hooks.ts";
import React from "react";
import { useUrlProvider } from "../../../useUrlProvider.ts";
import { getIcon } from "../../../taskManagement/taskPane/taskRelationsBox/TaskRelationsBox.tsx";
import { isNullOrWhitespace } from "../../stringOperations.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";

function MentionNode(props: NodeViewRendererProps) {
    const { node } = props;
    let { entityType, label, id, parentId, linkColor } = node.attrs;
    const urlProvider = useUrlProvider();
    const { translateString } = useTranslation();

    // Bliver brugt som en fallback, når brugeren har valgt en mention, men refresher siden.
    // Hvis der ikke eksistere en mention eller en label i node.attrs
    if (isNullOrWhitespace(label ?? null)) {
        let item = sessionStorage.getItem(`mention_${id}`);
        if (item) {
            const defaultValue = JSON.parse(item);
            label = defaultValue.label;
            parentId = defaultValue.parentId;
        }
    }

    const shouldDisplayAsLink = !isNullOrWhitespace(label ?? null);
    if (!shouldDisplayAsLink) {
        label = translateString("dataCouldNotBeFound");
        parentId = "";
    }

    const getMention = () => {
        return (
            <>
                <Box
                    component="span"
                    sx={(theme) => ({
                        marginRight: "2px",
                        "& svg": {
                            width: 14,
                            height: 14,
                            fill: "#DAD9EF",
                            marginBottom: "-2px",
                        },
                    })}
                >
                    {getIcon(Number(entityType))}
                </Box>
                {label}
            </>
        );
    };

    return (
        <NodeViewWrapper as="span">
            <Box component="span">
                {shouldDisplayAsLink ? (
                    <DotLegalLink to={getLink(Number(entityType), id, parentId, urlProvider)} linkColor={linkColor ? linkColor : "primary"} bold>
                        {getMention()}
                    </DotLegalLink>
                ) : (
                    getMention()
                )}
            </Box>
        </NodeViewWrapper>
    );
}

export default MentionNode;
